import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Anchor from '../utils/Anchor';

const StyledIframe = styled.div`
  padding: 0;
  display: flex;
  justify-content: center;
`;

const Iframe = ({ content }) => {
  const { title, blockId, url, width, height } = content;
  return (
    <StyledIframe>
      <Anchor id={blockId} />
      <iframe
        width={width || '100%'}
        height={height || 700}
        src={url}
        frameBorder="0"
        title={title}
      />
    </StyledIframe>
  );
};

Iframe.propTypes = {
  content: PropTypes.object,
};

export default Iframe;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/embed/Iframe.js